// #1280: Search full returned inventory, including prints beyond the first 50.
const normalize = (text) => String(text ?? "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase().trim();

export const filterTrainerInventoryBoard = (rows = [], search = "") => {
  const term = normalize(search);
  if (!term) return rows;
  return rows.filter((row) => normalize(row.card_name).includes(term));
};

export const paginateTrainerInventoryBoard = (rows = [], page = 0, pageSize = 25) =>
  rows.slice(page * pageSize, (page + 1) * pageSize);
